import * as React from 'react'
import { Jaw } from '../../../shared/Constants'
import { Utils } from '../../../shared/Utils'
import { Routes } from '../../Routes'

interface IProps {
  jaw: Jaw
}

export class JawView extends React.Component<IProps> {
  render(): React.ReactNode {
    const { jaw } = this.props
    const jawRoutes = Routes.getJawRoute(jaw)

    return (<div>
      {Utils.renderRoutes(jawRoutes.subRoutes)}
    </div>)
  }
}
